export default "__VITE_ASSET__CPjYHsjJ__"